import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  width: 380px;
  text-align: center;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  position: relative;
  max-height: 90vh;
  overflow: hidden;
  font-family: "Roboto", sans-serif;
`;

export const Input = styled.input`
  width: 95%;
  padding: 10px 12px;
  margin: 12px 0;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 15px;
  box-sizing: border-box;
`;

export const Button = styled.button`
  padding: 10px 20px;
  background: #a61c14;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  margin-top: 16px;
  font-size: 16px;
  font-weight: bold;
  transition: background 0.3s ease;

  &:hover {
    background: #881811;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #a61c14;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    color: #881811;
  }
`;

export const SearchResults = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 12px;
  max-height: 160px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #fff;
`;

export const SearchResultItem = styled.li`
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.2s ease;

  &:hover {
    background: #f8eaea;
  }
`;

export const LoadingRow = styled.li`
  display: flex;
  justify-content: center;
  padding: 8px 0;
  list-style: none;
  border-bottom: none;
  cursor: default;
`;

export const MessageRow = styled(LoadingRow)`
  color: #666;
  font-size: 15px;
`;

export const ProductDetailsSection = styled.div`
  margin-top: 20px;
  padding: 16px;
  background: #fdf1f0;
  border: 1px solid #f0d4d4;
  border-radius: 12px;
  text-align: left;
`;

export const ProductDetailItem = styled.div`
  font-size: 15px;
  margin-bottom: 10px;

  strong {
    color: #a61c14;
  }
`;
